import React, { Fragment } from 'react';
import { Champtionship } from '~/web-frontend-components/line/matches/list/sport/Championship';
export const Sport = (props) => <Fragment> {props.sport.sortedChampionshipIds.map((championshipID) => {
        const championship = {
            enChampionship: props.championships[championshipID].enChampionship,
            championshipID,
        };
        const getMatchURL = (match) => props.getMatchURL(championship, match);
        return <Champtionship {...props} url={props.getChampionshipURL(championship)} getMatchURL={getMatchURL} championship={props.championships[championshipID]} championshipID={championshipID} key={championshipID}/>;
    })} </Fragment>;



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/Sport.jsx